// Guidance only: browser strings cannot reveal which permission layer is blocked.
export function detectMicrophonePlatform(userAgent = typeof navigator === 'undefined' ? '' : navigator.userAgent || '') {
  const ios = /iPhone|iPad|iPod/i.test(userAgent)
    || (/Macintosh/i.test(userAgent) && /Mobile\//i.test(userAgent));
  const otherBrowser = /Edg|OPR|Opera|SamsungBrowser|Firefox|FxiOS|DuckDuckGo|YaBrowser|Vivaldi|Brave|GSA|FBAN|FBAV|Instagram|; wv\)/i.test(userAgent);
  if (otherBrowser) return 'other';
  if (ios && /CriOS\//.test(userAgent)) return 'ios-chrome';
  if (ios && /Version\/[\d.]+.*Safari\//.test(userAgent) && !/CriOS/.test(userAgent)) return 'ios-safari';
  if (/Android/i.test(userAgent) && /Chrome\//.test(userAgent) && !/Version\//.test(userAgent)) return 'android-chrome';
  return 'other';
}
